<template>
  <div class="ee-editor pa-2">
    <div class="v-label pb-2">{{ title }}</div>
    <v-chip
      v-for="(item, index) in items"
      :key="index"
      class="mt-2"
      :close="index == items.length - 1"
      @click="edit(item, index)"
      @click:close="remove(index)"
      >{{ item.value
      }}{{
        item.funcName ? "." + item.funcName + "(" + item.funcParam + ")" : ""
      }}</v-chip
    >
    <v-chip @click="add" color="success" class="mt-2">
      <v-icon>mdi-plus</v-icon>
    </v-chip>

    <v-dialog v-model="dialog" width="400" scrollable>
      <v-card>
        <v-card-title>{{ dialogTitle }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-container>
            <v-row>
              <v-col v-if="type == 'calculate'" cols="12">
                <CalculationPicker title="Calculation" v-model="dataValue" />
              </v-col>
              <v-col v-else cols="12">
                <ServerDataTypePicker
                  v-if="dataIsValue"
                  title="Value Type"
                  v-model="valueType"
                  class="mb-6"
                />
                <ServerFieldValuePicker
                  title="Value"
                  v-model="dataValue"
                  :type="valueType"
                  class="mb-6"
                />
                <ExpressionFunctionPicker
                  title="Function"
                  v-model="funcName"
                  class="mb-6"
                />
                <v-text-field
                  filled
                  label="Function Parameter"
                  v-model="funcParam"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" :disabled="!dataValue" @click="submit"
            >OK</v-btn
          >
          <v-btn text color="error" @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CalculationPicker from "./CalculationPicker.vue";
import ServerDataTypePicker from "./ServerDataTypePicker.vue";
import ServerFieldValuePicker from "./ServerFieldValuePicker.vue";
import ExpressionFunctionPicker from "./ExpressionFunctionPicker.vue";

export default {
  name: "ServerCalculationEditor",

  components: {
    CalculationPicker,
    ServerDataTypePicker,
    ServerFieldValuePicker,
    ExpressionFunctionPicker,
  },

  props: ["title", "value"],

  data() {
    return {
      items: [],
      dialog: false,
      activeItemIndex: -1,
      dialogTitle: null,

      type: "value",
      dataValue: null,
      valueType: "text",
      funcName: null,
      funcParam: null,
    };
  },

  watch: {
    value() {
      this.refresh();
    },
  },

  computed: {
    dataIsValue() {
      if (this.dataValue) {
        var s = this.dataValue.toString().split(".")[0];
        return (
          s != "data" && s != "field" && s != "variable" && s != "function"
        );
      }

      return true;
    },
  },

  mounted() {
    this.refresh();
  },

  methods: {
    refresh() {
      if (this.value) {
        this.items = this.value;
      } else {
        this.items = [];
      }
    },
    add() {
      var prevItem;

      if (this.items.length > 0) {
        prevItem = this.items[this.items.length - 1];
      } else {
        this.type = "value";
      }

      if (prevItem) {
        if (prevItem.type == "calculate") {
          this.type = "value";
        } else {
          this.type = "calculate";
        }
      }

      this.dataValue = null;
      this.valueType = "text";
      this.funcName = null;
      this.funcParam = null;

      this.activeItemIndex = -1;
      this.dialogTitle = "Add";
      this.dialog = true;
    },
    edit(item, index) {
      this.type = item.type;
      this.dataValue = item.value;
      this.valueType = item.valueType;
      this.funcName = item.funcName;
      this.funcParam = item.funcParam;

      this.activeItemIndex = index;
      this.dialogTitle = "Edit";
      this.dialog = true;
    },
    submit() {
      if (this.activeItemIndex == -1) {
        this.items.push({
          type: this.type,
          value: this.dataValue,
          valueType: this.valueType,
          funcName: this.funcName,
          funcParam: this.funcParam,
        });
      } else {
        var item = this.items[this.activeItemIndex];
        item.type = this.type;
        item.value = this.dataValue;
        item.valueType = this.valueType;
        item.funcName = this.funcName;
        item.funcParam = this.funcParam;
      }

      this.dialog = false;
      this.$emit("input", this.items);
    },
    remove(index) {
      this.items.splice(index, 1);
      this.$emit("input", this.items);
    },
  },
};
</script>

<style scoped>
.ee-editor {
  background: #fff;
  border: 1px solid #ccc;
}
</style>